import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CompanyLogo } from "../../../components/CompanyLogo";
import { Settings } from "@mui/icons-material";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import { Skeleton } from "../../../components/loading";
import { useNavigate } from "react-router-dom";

export function ProductSummary(props: {
  productName: string;
  productDescription: string;
  vendorName: string;
  vendorUrl: string;
  vendorId: number;
  isLoading: boolean;
}) {
  const navigate = useNavigate();
  const handleVendorClick = () => {
    navigate(`/catalog/product/vendor/${props.vendorId}`);
  };
  return (
    <OutlinedPaper
      id="product-summary-card"
      data-testid="catalog-product-summary-card"
      sx={{ p: 2 }}
    >
      <Stack gap={1}>
        <Box display="flex" gap={1}>
          <Box sx={{ width: "64px" }}>
            <Skeleton
              isLoading={props.isLoading}
              width={64}
              height={64}
              variant="circular"
            >
              <CompanyLogo
                size={64}
                fallback={<Settings />}
                domain={props.vendorUrl}
                variant="circular"
              />
            </Skeleton>
          </Box>
          <Stack gap={1}>
            <Skeleton isLoading={props.isLoading} width={140} height={25}>
              <Typography variant="h3">{props.productName}</Typography>
            </Skeleton>
            <Box mt="4px" display="flex" gap="4px">
              <Typography variant="body2">Vendor:</Typography>
              <Skeleton isLoading={props.isLoading} width={100} variant="text">
                <Typography variant="body2">
                  <Link
                    id="vendor-link"
                    data-testid="catalog-product-vendor-link"
                    component="button"
                    underline="none"
                    onClick={handleVendorClick}
                    sx={{ textAlign: "left" }}
                  >
                    {props.vendorName}
                  </Link>
                </Typography>
              </Skeleton>
            </Box>
          </Stack>
        </Box>
        <Box mt="8px">
          <Skeleton isLoading={props.isLoading} height={100}>
            <Typography variant="body1">{props.productDescription}</Typography>
          </Skeleton>
        </Box>
      </Stack>
    </OutlinedPaper>
  );
}
